<script>
import { validateEmailAddress } from "@/utils";
import { addEmailSenders } from "@/api/accounts.js";
import swal from "sweetalert";
export default {
  name: "add-email-sender-detail",
  data() {
    return {
      form: {
        email: null,
        default: false
      }
    };
  },
  methods: {
    async onSubmit() {
      if (!validateEmailAddress(this.form.email)) {
        swal("Error", "Not a valid email address");
        return;
      }
      // console.log(this.form);
      const response = await addEmailSenders(this.form);
      if (response && response.success) {
        this.form.email = null;
        swal("Email Sender", "Successfully added");
        this.$store.dispatch("getEmailSenders");

        let flowId = window.localStorage.getItem("flowReturn");
        if (flowId) {
          this.$router.push(`/flows/builder/${flowId}`);
        }
      } else {
        swal(
          "Oops",
          "Something went wrong. Please try a different valid email address"
        );
      }
    }
  }
};
</script>

<template>
  <div class="p-5">
    <b-form
      v-on:submit.prevent="onSubmit"
      method="POST"
      accept-charset="UTF-8"
      enctype="multipart/form-data"
      id="mainForm"
      inline
    >
      <label class="sr-only" for="inline-form-input-email">Email</label>
      <b-input-group
        prepend="Email"
        class="mb-2 mr-sm-2 mb-sm-0"
        style="width:300px"
      >
        <b-form-input
          type="email"
          id="inline-form-input-email"
          placeholder="Need a valid email address"
          v-model="form.email"
          required
        ></b-form-input>
      </b-input-group>
      <b-button type="submit" variant="primary">Save</b-button>
    </b-form>
  </div>
</template>
